export const statusOptions = [
  {
    label: '未反馈',
    value: 0
  },
  {
    label: '不感兴趣',
    value: 1
  },
  {
    label: '感兴趣',
    value: 2
  },
  {
    label: '立项',
    value: 3
  }
];
export const getStatusLabel = value => {
  const status = statusOptions.find(item => item.value === value);
  return status ? status.label : '';
};
